import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  useEffect(() => {
    const toggler = document.querySelector('.mobile-nav-toggler');
    const menu = document.querySelector('.mobile-menu');
    const closeBtn = document.querySelector('.mobile-menu .close-btn');
    const backdrop = document.querySelector('.mobile-menu .menu-backdrop');

    const openMenu = () => {
      menu?.classList.add('menu-visible');
      document.body.classList.add('mobile-menu-visible');
    };

    const closeMenu = () => {
      menu?.classList.remove('menu-visible');
      document.body.classList.remove('mobile-menu-visible');
    };

    toggler?.addEventListener('click', openMenu);
    closeBtn?.addEventListener('click', closeMenu);
    backdrop?.addEventListener('click', closeMenu);

    return () => {
      toggler?.removeEventListener('click', openMenu);
      closeBtn?.removeEventListener('click', closeMenu);
      backdrop?.removeEventListener('click', closeMenu);
    };
  }, []);

  return (
    <>
      <header className="main-header header-style-five">
        <div className="header-lower">
          <div className="auto-container">
            <div className="outer-box">
              <div className="logo-box">
                <figure className="logo">
                  <Link to="/">
                    <img src="/assets/images/header-logo.png" className="header-logo" alt="Wications Logo" />
                  </Link>
                </figure>
              </div>

              <div className="menu-area">
                <div className="mobile-nav-toggler">
                  <i className="icon-bar"></i>
                  <i className="icon-bar"></i>
                  <i className="icon-bar"></i>
                </div>

                <nav className="main-menu navbar-expand-md navbar-light clearfix">
                  <ul className="navigation clearfix">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about">About</Link></li>
                    <li><Link to="/services">Services</Link></li>
                    <li><Link to="/translations">Translations</Link></li>
                  </ul>
                </nav>
              </div>

              <div className="menu-right-content">
                <div className="btn-box">
                  <Link to="/contact" className="theme-btn btn-one">Get Started</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}

      <div className="mobile-menu">
  <div className="menu-backdrop"></div>
  <div className="menu-box">
    <div className="close-btn"><i className="fas fa-times"></i></div>
    <div className="nav-logo">
      <Link to="/"><img src="/assets/images/header-logo.png" alt="Wications Logo" /></Link>
    </div>
    <ul className="navigation">
      <li><Link to="/">Home</Link></li>
      <li><Link to="/about">About</Link></li>
      <li><Link to="/services">Services</Link></li>
      <li><Link to="/translations">Translations</Link></li>
    </ul>

        <div className="contact-info">
            <h4>Contact Info</h4>
            <ul>
              <li>114 2nd Cross Rd, Wattala, Sri Lanka</li>
              <li><a href="tel:94-11-2655017">94-11-2655017</a></li>
              <li><a href="mailto:info@wications.com">info@wications.com</a></li>
            </ul>
          </div>
          </div>
        </div>

    </>
  );
};

export default Header;